<template>
<div>
  <div class="wistia_embed wistia_async_xn5vqouwvi">
    &nbsp;
  </div>

  <div
    id="all-choices"
    class="tbk-vid-embed"
  >
    <a
      id="choice-1"
      class="embedded_video"
      href="#wistia_b8aw7t833z?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="choice-2"
      class="embedded_video"
      href="#wistia_zqnhv8gbvs?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="choice-3"
      class="embedded_video"
      href="#wistia_r8q8ccwxk5?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="choice-4"
      class="embedded_video"
      href="#wistia_81iyu4dt6t?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="choice-5"
      class="embedded_video"
      href="#wistia_6x9ririw1l?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="choice-6"
      class="embedded_video"
      href="#wistia_4ul3uuomvz?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('xn5', 30, this.showSelect)
    this.tbk.loadCrossTime('b8a', 154, this.showSelect)
    this.tbk.loadCrossTime('zqn', 206, this.showSelect)
    this.tbk.loadCrossTime('r8q', 202, this.showSelect)
    this.tbk.loadCrossTime('81i', 212, this.showSelect)
    this.tbk.loadCrossTime('6x9', 142, this.showSelect)
    this.tbk.loadCrossTime('4ul', 168, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        b8a: this.tbk.autoPlay,
        zqn: this.tbk.autoPlay,
        r8q: this.tbk.autoPlay,
        '81i': this.tbk.autoPlay,
        '6x9': this.tbk.autoPlay,
        '4ul': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#all-choices
  display: none
  a
    text-decoration: none
#choice-1
  position: absolute
  top: calc(100% * (105 / 360))
  left: calc(100% * (45 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (115 / 360))
#choice-2
  position: absolute
  top: calc(100% * (105 / 360))
  left: calc(100% * (230 / 640))
  width: calc(100% * (185 / 640))
  height: calc(100% * (115 / 360))
#choice-3
  position: absolute
  top: calc(100% * (105 / 360))
  left: calc(100% * (418 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (115 / 360))
#choice-4
  position: absolute
  top: calc(100% * (225 / 360))
  left: calc(100% * (45 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (115 / 360))
#choice-5
  position: absolute
  top: calc(100% * (225 / 360))
  left: calc(100% * (230 / 640))
  width: calc(100% * (185 / 640))
  height: calc(100% * (115 / 360))
#choice-6
  position: absolute
  top: calc(100% * (220 / 360))
  left: calc(100% * (418 / 640))
  width: calc(100% * (180 / 640))
  height: calc(100% * (115 / 360))
</style>
